import endpointFactory from "./factory";

const EndPoint = endpointFactory("Owner", "owners");
export default [
  EndPoint("Subscriptions", "subscriptions"),
  EndPoint("Company", "company"),
  EndPoint("Offerings", "offerings"),
  EndPoint("CreditCards", "credit-cards"),
  EndPoint("Coaches", "coaches"),
  EndPoint("ClientOfferings", "client-offerings"),
  EndPoint("SubDomains", "subdomains")
];
